import React, { useState } from "react";
import UploadImageModal from "../../components/image/UploadImageModal";
import { useEventParticipationSubmission } from "../../context/EventParticipationSubmissionManager";

function EventParticipationVehicleImageUpload() {
    const { updateFormData } = useEventParticipationSubmission();

    const [showImageUploadModal, setShowImageUploadModal] = useState(false);

    const imageUploaded = (response) => {
        console.log(response);
        if (response && response?.data?.image?.id && response?.data?.image?.url) {
            updateFormData("vehicleImageId", response.data.image.id);
            updateFormData("vehicleImageUrl", response.data.image.url);
        }
    };

    return (
        <React.Fragment>
            <UploadImageModal
                show={showImageUploadModal}
                handleClose={() => setShowImageUploadModal(false)}
                requestUrl="/uploadEventParticipationSubmissionVehicleImage"
                imageUploaded={imageUploaded}
                requestParameters={{}}
            />
            <button
                type="button"
                className="btn btn-outline-secondary mb-3"
                onClick={() => setShowImageUploadModal(true)}
            >
                Upload afbeelding
            </button>
        </React.Fragment>
    );
}

export default EventParticipationVehicleImageUpload; 
